import React from "react";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../../components/marathiNumbers";
import { Link } from "react-router-dom";

const Conversation = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const content = {
    English: {
      title: "Preservation and Conservation",
      breadcrumbHome: "HOME",
      breadcrumb: "PRESERVATION AND CONSERVATION",
      Paragraph1:
        "Preservation, Conservation and protection of all monuments collectively are few of the main functions of the Directorate along with Exploration and Excavation. The directorate is duty bound to protect, conserve and preserve all the monuments declared as ‘Protected Monuments’ under the ‘Maharashtra Ancient Monument and Archaeological Sites and Remains Act, 1960’.",
      Paragraph2:
        "The primary function of the Directorate protects, conserve and preserve all monuments declared as the protected monument of State importance under the ‘Maharashtra Ancient Monument and Archaeological Sites and Remains Act, 1960’.",
      Paragraph3:
        "The act mentioned helps to make better provisions for the preservation of ancient and historical monuments and also for recording the archaeological sites and remains (other than those declared to be of national importance) in the state of Maharashtra.",
      Paragraph4:
        "Further steps that are deemed as important functions of the Directorate include documentation of unprotected heritage in the form of tangible evidence discovered from planned archaeological exploration and excavation as well as accidental discoveries. On the basis of this, data protection proposals are submitted to the Ministry of Cultural Affairs for approval and publication of Gazette Notification for protection of ancient monuments and archaeological sites is carried out.",
      stepsTitle: "Steps taken for the protection of the monument:",
      steps1:
        "The Assistant Director, in charge of Divisional office, takes initiative through field officer for documentation and photography of a particular monument intended to be protected in a prescribed proforma and it is forwarded to Director of Archaeology and Museums.",
      steps2:
        "The Director of Archaeology and Museums forwards the same along with comments and reasoning to the Principal Secretary, Culture.",
      steps3:
        "The Department of Cultural Affairs issues a preliminary Gazette Notification and draft notice, which is pasted on monument under consideration for public display.",
      steps4:
        "As prescribed in the Act, two months minimum period is given to any individual or any public in general for raising the objection against the above notice.",
      steps5:
        "If any such objection is received by the Directorate, the same is brought to notice of the Principal Secretary, Cultural Affairs.",
      steps6:
        "If no objection is received in the said period of two months then the Government of Maharashtra issues Gazette Notification declaring a certain monument as the State Protected Monument/Archaeological Site under the Maharashtra Ancient Monument and Archaeological Sites and Remains Act 1960.",
      steps7:
        "The same is considered for conservation and preservation. The process regarding conservation is carried out by The Directorate of Archaeology and Museums as per available funds and manpower.",
      finalNote:
        "The Directorate of Archaeology and Museums has protected 386 monuments/ancient sites till date wherein final notifications are issued in case of 302 monuments. Remaining monuments are still under the preliminary process of protection and shall be declared state-protected monuments after approval of the Government.",
      tablename: "Conservation Workdone by Directorate",
    },
    मराठी: {
      title: "जतन आणि संवर्धन",
      breadcrumbHome: "मुख्यपृष्ठ ",
      breadcrumb: "जतन आणि संवर्धन",
      Paragraph1:
        "शोध आणि उत्खननाबरोबरच सर्व स्मारकांचे संरक्षण, संवर्धन आणि जतन करणे, हे संचालनालयाचे प्रमुख कार्य आहे. 'महाराष्ट्र्र प्राचीन स्मारके व पुराणवास्तूशास्त्र विषयक स्थळे व अवशेष अधिनियम, १९६०' नुसार, 'संरक्षित स्मारक' म्हणून घोषित करण्यात आलेल्या स्थळांचे संरक्षण, संवर्धन आणि जतन करण्यास संचालनालय बांधील आहे.",
      Paragraph2:
        "'महाराष्ट्र प्राचीन स्मारके व पुराणवास्तूशास्त्र विषयक स्थळे व अवशेष अधिनियम १९६०' च्या आधीन राहून 'राज्य संरक्षित स्मारक' म्हणून घोषित करण्यात आलेल्या सर्व स्मारकांचे संरक्षण, संवर्धन आणि जतन करणे हे संचालनालयाचे प्राथमिक कार्य आहे.",
      Paragraph3:
        "उपरोल्लेखित कायद्यामुळे महाराष्ट्र राज्यातील प्राचीन आणि ऐतिहासिक स्थळांच्या ('राष्ट्रीय महत्वाची' म्हणून घोषित झालेली स्मारके वगळता) जतनासाठी आणि नोंदीसाठी चांगल्या तरतुदी करण्यास मदत होते.",
      Paragraph4:
        "नियोजित पुराणवस्तूविषयक अन्वेषण, उत्खनन आणि आकस्मिक शोधातून मिळालेल्या मूर्त पुराव्यांच्या आधारे असंरक्षित स्मारकांचे दस्तावेजीकरण करण्याबरोबरच पुढील क्रम संचालनालयाच्या कामात महत्वाचा मानला जातो. त्यांच्याच आधारे, प्राचीन स्मारके आणि पुराणवस्तूविषयक स्थळांच्या संरक्षणासाठी, निविदा संरक्षणाचा प्रस्ताव सांस्कृतिक कार्य मंत्रालयाच्या मंजुरीसाठी आणि राजपत्र अधिसूचना प्रसिद्ध करण्यासाठी सादर केला जातो.",
      stepsTitle: "स्मारकाच्या संरक्षण प्रक्रियेचा क्रम :",
      steps1:
        "विभागीय कार्यालयाचे प्रभारी, सहायक संचालक हे क्षेत्र अधिकाऱ्यांच्या माध्यमातून संबंधित संरक्षित करावयाच्या स्मारकाचे विहित नमुन्यात दस्तावेजीकरण आणि छायाचित्रीकरण करतात. हा प्रस्ताव पुरातत्त्व आणि वस्तुसंग्रहालये संचालकांना पाठवण्यात येतो.",
      steps2:
        "पुरातत्त्व आणि वस्तुसंग्रहालये संचालक आपल्या विचार आणि टिप्पणीसह हा प्रस्ताव सांस्कृतिक विभागाच्या प्रधान सचिवांकडे पाठवतात.",
      steps3:
        "सांस्कृतिक कार्य विभागातर्फे प्राथमिक अधिसूचना काढली जाते. ती संबंधित स्मारकावर जाहीरपणे लावली जाते.",
      steps4:
        "कायद्यात नमूद केल्याप्रमाणे, या अधिसूचनेवर आक्षेप नोंदवण्यासाठी संबंधित अथवा सर्वसाधारण कोणत्याही व्यक्तीला दोन महिन्यांचा वेळ दिला जातो.",
      steps5:
        "संचालनालयाला प्राप्त झालेल्या आक्षेपांबाबत प्रधान सचिव, सांस्कृतिक कार्ये, यांना अवगत केले जाते.",
      steps6:
        "दोन महिन्यांच्या विहित कालावधीत आक्षेप न आल्यास महाराष्ट्र शासन संबंधित स्मारकास 'महाराष्ट्र प्राचीन स्मारके आणि पुराणवस्तूविषयक स्थळे आणि अवशेष अधिनियम, १९६०' अन्वये, 'राज्य संरक्षित स्मारक/पुरातात्विक स्थळ' घोषित करण्यासाठी राजपत्र प्रसिद्ध करते.",
      steps7:
        "संवर्धन आणि जतनासाठी ते ग्राह्य धरले जाते. पुरातत्त्व आणि वस्तुसंग्रहालये संचालनालयामार्फत उपलब्ध निधी आणि मनुष्यबळानुसार संवर्धनाची प्रक्रिया सुरु केली जाते.",
      finalNote:
        "पुरातत्त्व आणि वस्तुसंग्रहालये संचालनालयाने आतापर्यंत ३८६ स्मारके / पुरातात्विक स्थळे संरक्षित केली आहेत. तसेच ३०२ स्मारकांची अंतिम अधिसूचना जरी केली आहे. उर्वरित स्मारके संरक्षित होण्याच्या प्राथमिक प्रक्रियेत असून शासनाच्या मंजुरीनंतर 'राज्य संरक्षित स्मारके' घोषित केली जातील.",
      tablename: "संचालनालयाने केलेले संवर्धन कार्य",
    },
  };

  const tableHeaders = {
    tableheadinf: "Conservation Workdone by Directorate",
    srNo: {
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    nameofmonument: {
      English: "Name of Monument",
      मराठी: "स्मारकाचे नाव",
    },
    dateofsubmission: {
      English: `Date of Submission of Proposal to the Government`,
      मराठी: `सरकारला प्रस्ताव सादर करण्याची तारीख`,
    },
    dateofapproval: {
      English: `Date of Administrative Approval`,
      मराठी: `प्रशासकीय मंजुरीची तारीख`,
    },
    commencement: {
      English: `Commencement of Work`,
      मराठी: `कामाची सुरुवात`,
    },
    completion: {
      English: `Completion of Work`,
      मराठी: `काम पूर्ण करणे`,
    },
  };

  const t = content[selectedLang];

  const conservationData = [
    {
      division: {
        English: "Ratnagiri Division",
        मराठी: "रत्नागिरी विभाग",
      },
      district: {
        English: "District Mumbai",
        मराठी: "जिल्हा मुंबई",
      },
      entries: [
        {
          name: {
            English: "Dharavi Fort, Dharavi, Mumbai",
            मराठी: "धारावी किल्ला, धारावी, मुंबई",
          },
          proposal: {
            English: "21.02.2019",
            मराठी: "२१.०२.२०१९",
          },
          approval: {
            English: "01.03.2019",
            मराठी: "०१.०३.२०१९",
          },
          start: {
            English: "19.09.2019",
            मराठी: "१९.०९.२०१९",
          },
          end: {
            English: "18.09.2021",
            मराठी: "१८.०९.२०२१",
          },
        },
      ],
    },
    {
      district: {
        English: "District Ratnagiri",
        मराठी: "जिल्हा रत्नागिरी",
      },
      entries: [
        {
          name: {
            English: "Bankot Fort, Bankot, Dist. Ratnagiri",
            मराठी: "बांकोट किल्ला, बांकोट, जि. रत्नागिरी",
          },
          proposal: {
            English: "07.10.2016",
            मराठी: "०७.१०.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "28.02.2018",
            मराठी: "२८.०२.२०१८",
          },
          end: {
            English: "31.04.2021",
            मराठी: "३१.०४.२०२१",
          },
        },
        {
          name: {
            English: "Purnagad Fort, Purnagad, Ratnagiri District",
            मराठी: "पुर्णगड किल्ला, पुर्णगड, जि.रत्नागिरी",
          },
          proposal: {
            English: "17.06.2017",
            मराठी: "१७.०६.२०१७",
          },
          approval: {
            English: "01.08.2017",
            मराठी: "०१.०८.२०१७",
          },
          start: {
            English: "01.04.2018",
            मराठी: "०१.०४.२०१८",
          },
          end: {
            English: "31.12.2020",
            मराठी: "३१.१२.२०२०",
          },
        },
      ],
    },
    {
      district: {
        English: "District Sindhudurg",
        मराठी: "जिल्हा सिंधुदुर्ग",
      },
      entries: [
        {
          name: {
            English: "Yashwantgad Fort, Redi, Dist. Sindhudurg",
            मराठी: "यशवंतगड किल्ला, रेडी, जि. सिंधुदुर्ग",
          },
          proposal: {
            English: "07.10.2016",
            मराठी: "०७.१०.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "27.03.2018",
            मराठी: "२७.०३.२०१८",
          },
          end: {
            English: "28.02.2020",
            मराठी: "२८.०२.२०२०",
          },
        },
        {
          name: {
            English: "Bharatgad Fort, Masure, Tal. Malvan, Dist. Sindhudurg",
            मराठी: "भरतगड किल्ला, मसूरे, ता. मालवण जि. सिंधुदुर्ग",
          },
          proposal: {
            English: "07.10.2016",
            मराठी: "०७.१०.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "21.03.2018",
            मराठी: "२१.०३.२०१८",
          },
          end: {
            English: "21.03.2018",
            मराठी: "२१.०३.२०१८",
          },
        },
        {
          name: {
            English: "Sindhudurg Fort, Preparation of Site Management Plan",
            मराठी: "सिंधुदूर्ग किल्ला, साईट मॅनेजमेंट प्लान तयार करणे",
          },
          proposal: {
            English: "-",
            मराठी: "-",
          },
          approval: {
            English: "01.07.2021",
            मराठी: "०१.०७.२०२१",
          },
          start: {
            English: "08.04.2022",
            मराठी: "०८.०४.२०२२",
          },
          end: {
            English: "08.11.2022",
            मराठी: "०८.११.२०२२",
          },
        },
        {
          name: {
            English:
              "Preparation of Site Management Plan for Vijaydurg Fort, Sindhudurg District",
            मराठी:
              "विजयदुर्ग किल्ला, जि.सिंधूदुर्ग साईट मॅनेजमेंट प्लान तयार करणे",
          },
          proposal: {
            English: "-",
            मराठी: "-",
          },
          approval: {
            English: "01.07.2021",
            मराठी: "०१.०७.२०२१",
          },
          start: {
            English: "08.04.2022",
            मराठी: "०८.०४.२०२२",
          },
          end: {
            English: "03.08.2022",
            मराठी: "०३.०८.२०२२",
          },
        },
      ],
    },
    {
      division: {
        English: "Pune Division",
        मराठी: "पुणे विभाग",
      },
      district: {
        English: "District Pune",
        मराठी: "जिल्हा पुणे",
      },
      entries: [
        {
          name: {
            English:
              "Korigarh Fort, Ambawane, Mulshi Taluka, Pune District (Part-I)",
            मराठी: "कोयरीगड किल्ला,आंबवणे ता.मुळशी जि.पुणे (भाग-1)",
          },
          proposal: {
            English: "05.10.2016",
            मराठी: "०५.१०.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "21.08.2017",
            मराठी: "२१.०८.२०१७",
          },
          end: {
            English: "15.01.2021",
            मराठी: "१५.०१.२०२१",
          },
        },
        {
          name: {
            English:
              "Preparation of Site Management Plan for Shivneri Fort, Pune District",
            मराठी: "शिवनेरी किल्ला, जि.पुणे साईट मॅनेजमेंट प्लान तयार करणे",
          },
          proposal: {
            English: "-",
            मराठी: "-",
          },
          approval: {
            English: "01.07.2021",
            मराठी: "०१.०७.२०२१",
          },
          start: {
            English: "08.04.2022",
            मराठी: "०८.०४.२०२२",
          },
          end: {
            English: "01.09.2022",
            मराठी: "०१.०९.२०२२",
          },
        },
      ],
    },
    {
      district: {
        English: "District Kolhapur",
        मराठी: "जिल्हा कोल्हापूर",
      },
      entries: [
        {
          name: {
            English: "Vishalgad, Gajapur, Tal. Shahuwadi, Dist. Kolhapur",
            मराठी: "विशाळगड, गजापूर, ता. शाहूवाडी, जि. कोल्हापूर",
          },
          proposal: {
            English: "06.09.2016",
            मराठी: "०६.०९.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "21.08.2017",
            मराठी: "२१.०८.२०१७",
          },
          end: {
            English: "10.08.2019",
            मराठी: "१०.०८.२०१९",
          },
        },
        {
          name: {
            English:
              "Rangana Fort Chikewadi, Bhudargad Taluka, Kolhapur District",
            मराठी: "रांगणा किल्ला चिकेवाडी, ता.भूदरगड जि.कोल्हापूर",
          },
          proposal: {
            English: "06.09.2016",
            मराठी: "०६.०९.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "21.08.2017",
            मराठी: "२१.०८.२०१७",
          },
          end: {
            English: "01.03.2020",
            मराठी: "०१.०३.२०२०",
          },
        },
      ],
    },
    {
      district: {
        English: "District Nashik",
        मराठी: "जिल्हा नाशिक",
      },
      entries: [
        {
          name: {
            English:
              "Renuka Devi Temple, Chandwad, Tal. Chandwad, Dist. Nashik",
            मराठी: "रेणूकादेवी मंदिर, चांदवड, ता. चांदवड, जि. नाशिक",
          },
          proposal: {
            English: "27.07.2015",
            मराठी: "२७.०७.२०१५",
          },
          approval: {
            English: "16.10.2015",
            मराठी: "१६.१०.२०१५",
          },
          start: {
            English: "21.04.2016",
            मराठी: "२१.०४.२०१६",
          },
          end: {
            English: "10.11.2017",
            मराठी: "१०.११.२०१७",
          },
        },
        {
          name: {
            English: "Galana Fort, Tal. Malegaon, Dist. Nashik",
            मराठी: "गाळणा किल्ला, ता. मालेगाव, जि. नाशिक",
          },
          proposal: {
            English: "09.12.2015",
            मराठी: "०९.१२.२०१५",
          },
          approval: {
            English: "16.01.2016",
            मराठी: "१६.०१.२०१६",
          },
          start: {
            English: "11.03.2016",
            मराठी: "११.०३.२०१६",
          },
          end: {
            English: "19.10.2020",
            मराठी: "१९.१०.२०२०",
          },
        },
        {
          name: {
            English: "Beautiful Narayan Temple, Nashik",
            मराठी: "सुंदर नारायण मंदिर,नाशिक",
          },
          proposal: {
            English: "28.04.2016",
            मराठी: "२८.०४.२०१६",
          },
          approval: {
            English: "13.07.2016",
            मराठी: "१३.०७.२०१६",
          },
          start: {
            English: "22.03.2017",
            मराठी: "२२.०३.२०१७",
          },
          end: {
            English: "31.03.2022",
            मराठी: "३१.०३.२०२२",
          },
        },
        {
          name: {
            English: "Tankai Fort, Ankai, Dist. Nashik",
            मराठी: "टंकाई किल्ला, अंकाई, जि.नाशिक",
          },
          proposal: {
            English: "21.10.2016",
            मराठी: "२१.१०.२०१६",
          },
          approval: {
            English: "02.03.2017",
            मराठी: "०२.०३.२०१७",
          },
          start: {
            English: "21.08.2017",
            मराठी: "२१.०८.२०१७",
          },
          end: {
            English: "24.02.2021",
            मराठी: "२४.०२.२०२१",
          },
        },
        {
          name: {
            English: "Mulher Fort, Mulher, Dist. Nashik",
            मराठी: "मुल्हेर किल्ला, मुल्हेर, जि.नाशिक",
          },
          proposal: {
            English: "25.06.2019",
            मराठी: "२५.०६.२०१९",
          },
          approval: {
            English: "09.09.2019",
            मराठी: "०९.०९.२०१९",
          },
          start: {
            English: "24.04.2018",
            मराठी: "२४.०४.२०१८",
          },
          end: {
            English: "30.06.2021",
            मराठी: "३०.०६.२०२१",
          },
        },
        {
          name: {
            English: "Laling Fort, Laling, Dist. Dhule",
            मराठी: "लळींग किल्ला, लळींग, जि.धुळे",
          },
          proposal: {
            English: "15.04.2017",
            मराठी: "१५.०४.२०१७",
          },
          approval: {
            English: "21.11.2017",
            मराठी: "२१.११.२०१७",
          },
          start: {
            English: "27.08.2018",
            मराठी: "२७.०८.२०१८",
          },
          end: {
            English: "27.06.2022",
            मराठी: "२७.०६.२०२२",
          },
        },
        {
          name: {
            English: "Ankai Fort, Ankai, Dist. Nashik",
            मराठी: "अंकाई किल्ला, अंकाई, जि.नाशिक",
          },
          proposal: {
            English: "21.10.2016",
            मराठी: "२१.१०.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "13.04.2018",
            मराठी: "१३.०४.२०१८",
          },
          end: {
            English: "31.03.2023",
            मराठी: "३१.०३.२०२३",
          },
        },
        {
          name: {
            English: "Salher Fort, Salher, Dist. Nashik",
            मराठी: "साल्हेर किल्ला, साल्हेर, जि.नाशिक",
          },
          proposal: {
            English: "12.04.2017",
            मराठी: "१२.०४.२०१७",
          },
          approval: {
            English: "13.11.2017",
            मराठी: "१३.११.२०१७",
          },
          start: {
            English: "26.04.2018",
            मराठी: "२६.०४.२०१८",
          },
          end: {
            English: "01.03.2023",
            मराठी: "०१.०३.२०२३",
          },
        },
      ],
    },
    {
      district: {
        English: "District Ahilyanagar",
        मराठी: "जिल्हा अहिल्यानगर",
      },
      entries: [
        {
          name: {
            English: "Kharda Fort, Kharda, Tal. Jamkhed, Dist. Ahilyanagar",
            मराठी: "खर्डा किल्ला, खर्डा, ता. जामखेड, जि. अहिल्यानगर",
          },
          proposal: {
            English: "07.12.2015",
            मराठी: "०७.१२.२०१५",
          },
          approval: {
            English: "16.01.2016",
            मराठी: "१६.०१.२०१६",
          },
          start: {
            English: "16.08.2016",
            मराठी: "१६.०८.२०१६",
          },
          end: {
            English: "31.05.2022",
            मराठी: "३१.०५.२०२२",
          },
        },
      ],
    },
    {
      district: {
        English: "District Chhatrapati Sambhajinagar",
        मराठी: "जिल्हा छत्रपती संभाजी नगर",
      },
      entries: [
        {
          name: {
            English: "Antur Fort, Tal. Kannad, Dist. Chhatrapati Sambhajinagar",
            मराठी: "अंतूर किल्ला, ता. कन्नड, जि. छत्रपती संभाजी नगर",
          },
          proposal: {
            English: "02.12.2015",
            मराठी: "०२.१२.२०१५",
          },
          approval: {
            English: "	11.12.2015",
            मराठी: "११.१२.२०१५",
          },
          start: {
            English: "15.03.2016",
            मराठी: "१५.०३.२०१६",
          },
          end: {
            English: "March 2017",
            मराठी: "मार्च २०१७",
          },
        },
        {
          name: {
            English: "Vetalwadi Fort, Tal. Soygaon, Dist.Chhatrapati Sambhajinagar",
            मराठी: "वेताळवाडी किल्ला, ता.सोयगाव,जि.छत्रपती संभाजी नगर",
          },
          proposal: {
            English: "06.09.2016",
            मराठी: "०६.०९.२०१६",
          },
          approval: {
            English: "01.03.2017",
            मराठी: "०१.०३.२०१७",
          },
          start: {
            English: "08.09.2017",
            मराठी: "०८.०९.२०१७",
          },
          end: {
            English: "December 2019",
            मराठी: "डिसेंबर २०१९",
          },
        },
      ],
    },
    {
      district: {
        English: "District Osmanabad",
        मराठी: "जिल्हा उस्मानाबाद",
      },
      entries: [
        {
          name: {
            English: "Paranda Fort, Paranda, Tal. Paranda, Dist. Osmanabad",
            मराठी: "परांडा किल्ला, परांडा, ता. परांडा, जि. उस्मानाबाद",
          },
          proposal: {
            English: "02.12.2015",
            मराठी: "०२.१२.२०१५",
          },
          approval: {
            English: "11.12.2015",
            मराठी: "११.१२.२०१५",
          },
          start: {
            English: "22.12.2016",
            मराठी: "२२.१२.२०१६",
          },
          end: {
            English: "04.10.2019",
            मराठी: "०४.१०.२०१९",
          },
        },
      ],
    },
    {
      district: {
        English: "District Beed",
        मराठी: "जिल्हा बीड",
      },
      entries: [
        {
          name: {
            English: "Dharur Fort, Dharur, Tal. Dharur, Dist. Beed",
            मराठी: "धारुर किल्ला, धारुर, ता. धारुर, जि. बीड",
          },
          proposal: {
            English: "07.12.2015",
            मराठी: "०७.१२.२०१५",
          },
          approval: {
            English: "16.01.2016",
            मराठी: "१६.०१.२०१६",
          },
          start: {
            English: "28.07.2016",
            मराठी: "२८.०७.२०१६",
          },
          end: {
            English: "December 2017",
            मराठी: "डिसेंबर २०१७",
          },
        },
        {
          name: {
            English: "Kedareshwar Temple, Dist. Beed (Stage - 1)",
            मराठी: "केदारेश्वर मंदिर जि.बीड (भाग-1)",
          },
          proposal: {
            English: "06.10.2016",
            मराठी: "०६.१०.२०१६",
          },
          approval: {
            English: "26.10.2016",
            मराठी: "२६.१०.२०१६",
          },
          start: {
            English: "14.08.2017",
            मराठी: "१४.०८.२०१७",
          },
          end: {
            English: "25.01.2021",
            मराठी: "२५.०१.२०२१",
          },
        },
      ],
    },
    {
      district: {
        English: "District Nanded",
        मराठी: "जिल्हा नांदेड",
      },
      entries: [
        {
          name: {
            English: "Kandhar Fort, Tal. Kandhar, Dist. Nanded",
            मराठी: "कंधार किल्ला, ता. कंधार, जि. नांदेड",
          },
          proposal: {
            English: "02.12.2015",
            मराठी: "०२.१२.२०१५",
          },
          approval: {
            English: "11.12.2015",
            मराठी: "११.१२.२०१५",
          },
          start: {
            English: "14.12.2016",
            मराठी: "१४.१२.२०१६",
          },
          end: {
            English: "June 2018",
            मराठी: "जून २०१८",
          },
        },
        {
          name: {
            English: "Mahur Fort, Mahur, Tal. Mahur, Dist. Nanded",
            मराठी: "माहूर किल्ला, माहूर, ता. माहूर, जि, नांदेड",
          },
          proposal: {
            English: "02.12.2015",
            मराठी: "०२.१२.२०१५",
          },
          approval: {
            English: "11.12.2015",
            मराठी: "११.१२.२०१५",
          },
          start: {
            English: "01.01.2017",
            मराठी: "०१.०१.२०१७",
          },
          end: {
            English: "June 2018",
            मराठी: "जून २०१८",
          },
        },
        {
          name: {
            English: "Renukadevi Temple, Mahur, Dist. Nanded",
            मराठी: "रेणूकादेवी मंदिर, माहूर, जि.नांदेड",
          },
          proposal: {
            English: "30.10.2017",
            मराठी: "३०.१०.२०१७",
          },
          approval: {
            English: "03.11.2017",
            मराठी: "०३.११.२०१७",
          },
          start: {
            English: "27.04.2018",
            मराठी: "२७.०४.२०१८",
          },
          end: {
            English: "30.06.2020",
            मराठी: "३०.०६.२०२०",
          },
        },
      ],
    },
    {
      district: {
        English: "District Washim",
        मराठी: "जिल्हा वाशिम",
      },
      entries: [
        {
          name: {
            English: "Poha Ves, Karanjalad, Dist. Washim",
            मराठी: "पोहा वेस, कारंजालाडा, जि.वाशिम",
          },
          proposal: {
            English: "06.01.2018",
            मराठी: "०६.०१.२०१८",
          },
          approval: {
            English: "01.08.2018",
            मराठी: "०१.०८.२०१८",
          },
          start: {
            English: "21.02.2019",
            मराठी: "२१.०२.२०१९",
          },
          end: {
            English: "16.03.2020",
            मराठी: "१६.०३.२०२०",
          },
        },
        {
          name: {
            English: "Delhi/Dilli Ves, Karanjalad, Dist. Washim (Stage-1)",
            मराठी: "दिल्ली वेस, कारंजालाड, जि.वाशिम (भाग-1)",
          },
          proposal: {
            English: "07.12.2017",
            मराठी: "०७.१२.२०१७",
          },
          approval: {
            English: "05.07.2018",
            मराठी: "०५.०७.२०१८",
          },
          start: {
            English: "23.01.2019",
            मराठी: "२३.०१.२०१९",
          },
          end: {
            English: "15.07.2020",
            मराठी: "१५.०७.२०२०",
          },
        },
        {
          name: {
            English: "Delhi/Dilli Ves, Karanjalad, Dist. Washim (Stage-2)",
            मराठी: "दिल्ली वेस, कारंजालाड, जि.वाशिम (भाग-2)",
          },
          proposal: {
            English: "07.10.2021",
            मराठी: "०७.१०.२०२१",
          },
          approval: {
            English: "13.10.2022",
            मराठी: "१३.१०.२०२२",
          },
          start: {
            English: "-",
            मराठी: "-",
          },
          end: {
            English: "-",
            मराठी: "-",
          },
        },
      ],
    },
  ];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Page Title and Breadcrumb */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumbHome}
            </Link>{" "}/{" "}</span>
            {t.breadcrumb}
        </p>
      </div>

      {/* Description Paragraphs */}
      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black space-y-4 mt-12 font-futura">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.Paragraph1}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.Paragraph2}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.Paragraph3}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.Paragraph4}
        </p>

        {/* Steps List */}
        <div className="mt-8">
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            {t.stepsTitle}
          </p>
          <ol className="list-decimal list-outside text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
            <li>{t.steps1}</li>
            <li>{t.steps2}</li>
            <li>{t.steps3}</li>
            <li>{t.steps4}</li>
            <li>{t.steps5}</li>
            <li>{t.steps6}</li>
            <li>{t.steps7}</li>
          </ol>
        </div>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] font-semibold text-black leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.finalNote}
        </p>
      </div>

      {/* Download Title */}
      <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-8 mt-16">
        {t.tablename}
      </h2>
      {/* Conservation Work Table */}
      <div className="max-w-7xl mx-auto">
        <div
          className="mt-6"
        >
          <div className="overflow-x-auto bg-[#EFEDE0] rounded-xl" style={{ border: "2px solid #F8D6BF" }}>
            <table className="min-w-full text-center text-black text-sm sm:text-base">
              <thead
                className="font-bold tracking-wide"
                style={{
                  textShadow: "0.3px 0.3px 0 black",
                }}
              >
                <tr>
                  <th
                    className="py-3 px-4 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.srNo[selectedLang]}
                  </th>
                  <th
                    className="py-3 px-4 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.nameofmonument[selectedLang]}
                  </th>
                  <th
                    className="py-3 px-4 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.dateofsubmission[selectedLang]}
                  </th>
                  <th
                    className="py-3 px-4 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.dateofapproval[selectedLang]}
                  </th>
                  <th
                    className="py-3 px-4 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.commencement[selectedLang]}
                  </th>
                  <th
                    className="py-3 px-4"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {tableHeaders.completion[selectedLang]}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  let globalSrNo = 1;
                  return conservationData.map((section) => (
                    <React.Fragment
                      key={`${section.division?.en || ''}-${section.district?.en || ''}`}
                    >
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center py-3 px-4 border-t-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {section.division && (
                            <>
                              <span
                                className="text-lg font-bold tracking-wide"
                                style={{ textShadow: "0.3px 0.3px 0 black" }}
                              >
                                {section.division[selectedLang]}
                              </span>
                              <br />
                            </>
                          )}
                          <span
                            className="text-base font-bold tracking-wide"
                            style={{ textShadow: "0.3px 0.3px 0 black" }}
                          >
                            {section.district[selectedLang]}
                          </span>
                        </td>
                      </tr>
                      {/* Entries */}
                      {section?.entries?.map((entry) => (
                        <tr key={entry.id || `${entry.name?.en}-${entry.proposal?.en}`}>
                          <td
                            className="py-3 px-4 border-t-2 border-r-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {selectedLang === "मराठी"
                              ? convertToMarathiNumber(globalSrNo++)
                              : globalSrNo++}
                            .
                          </td>
                          <td
                            className="py-3 px-4 border-t-2 border-r-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {entry?.name[selectedLang]}
                          </td>
                          <td
                            className="py-3 px-4 border-t-2 border-r-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {entry?.proposal[selectedLang]}
                          </td>
                          <td
                            className="py-3 px-4 border-t-2 border-r-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {entry?.approval[selectedLang]}
                          </td>
                          <td
                            className="py-3 px-4 border-t-2 border-r-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {entry?.start[selectedLang]}
                          </td>
                          <td
                            className="py-3 px-4 border-t-2"
                            style={{ borderColor: "#F8D6BF" }}
                          >
                            {entry?.end[selectedLang]}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ));
                })()}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conversation;
